/* eslint-disable */
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import React from 'react';
import { useEffect } from 'react';
import { Subject } from 'rxjs';
import styles from './NalAlert.module.scss';

export type AlertType = 'error' | 'warning' | 'info' | 'success';

export type AlertControlType = { open: boolean; data: { duration?: number; message?: string; type?: AlertType } };

type NalAlertPropType = {
    control: Subject<AlertControlType>;
};

export const NalAlert: React.FC<NalAlertPropType> = ({ control }) => {
    const [status, setStatus] = React.useState<boolean>(false);
    const [MESSAGE, setMessage] = React.useState<string>('');
    const [TYPE, setType] = React.useState<AlertType>('success');
    const [DURATION, setDuration] = React.useState<number>(6000);

    useEffect(() => {
        control.subscribe(({ open, data: { type, message, duration } }) => {
            setStatus(open);
            setType(type || 'success');
            setMessage(message || '');
            setDuration(duration || 6000);
        });
    });

    const handleClick = () => {
        setStatus(true);
    };

    const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setStatus(false);
    };

    return (
        <Snackbar open={status} autoHideDuration={DURATION} onClose={handleClose}>
            <Alert onClose={handleClose} severity={TYPE}>
                {MESSAGE}
            </Alert>
        </Snackbar>
    );
};

export default NalAlert;
